export const services = [
  {
    slug: "google-search-ads",
    name: "Google Search Ads",
    eyebrow: "Performance Marketing",
    title: "Capture high-intent buyers when they are actively searching.",
    summary:
      "We build conversion-focused Google Search campaigns that place your business in front of ready-to-buy customers at the exact moment they need your service.",
    intro:
      "The goal is simple: turn search demand into qualified leads, lower acquisition cost, and create a predictable pipeline for your business.",
    highlights: [
      "Keyword intent and audience targeting",
      "Landing page alignment for stronger conversion rates",
      "Budget optimization across high-intent campaigns",
      "Transparent reporting and performance tracking",
    ],
    benefits: [
      "Reach customers already looking for your service",
      "Reduce wasted spend with tighter targeting",
      "Scale profitable campaigns with data-backed decisions",
    ],
    idealFor: "Businesses that need leads quickly and want measurable, transparent growth from search traffic.",
    cta: "Turn your search traffic into qualified leads.",
  },
  {
    slug: "seo",
    name: "SEO",
    eyebrow: "Organic Growth",
    title: "Build long-term visibility and sustainable traffic growth.",
    summary:
      "Our SEO strategies help your site rank for the right keywords, attract quality traffic, and turn search visibility into sustainable business growth.",
    intro:
      "We combine technical SEO, content strategy, and local search optimization to improve rankings, authority, and conversions over time.",
    highlights: [
      "Technical audits and on-page optimization",
      "Local SEO for service-area businesses",
      "Content strategy built around buyer intent",
      "Ongoing ranking and performance improvement",
    ],
    benefits: [
      "Gain compounding visibility over time",
      "Attract visitors who are actively searching for your offer",
      "Reduce reliance on paid traffic alone",
    ],
    idealFor: "Brands that want consistent traffic, stronger search rankings, and long-term digital authority.",
    cta: "Create an SEO engine that keeps bringing in demand.",
  },
  {
    slug: "local-services-ads",
    name: "Local Services Ads",
    eyebrow: "Local Lead Generation",
    title: "Show up at the top when local customers need your service now.",
    summary:
      "Local Services Ads help service businesses appear above the regular results and connect directly with customers who need local help immediately.",
    intro:
      "These campaigns are built to drive qualified local leads and create a stronger presence in high-intent local search results.",
    highlights: [
      "Google Local Services setup and optimization",
      "Geo-targeted lead generation strategy",
      "Improved trust via Google verification and rankings",
      "Fast response workflows to convert inquiries",
    ],
    benefits: [
      "Increase visibility in local search results",
      "Capture more ready-to-buy leads",
      "Strengthen your local reputation and conversion rate",
    ],
    idealFor: "Home service businesses, local contractors, and service providers who depend on nearby customers.",
    cta: "Put your business in front of local customers ready to book.",
  },
  {
    slug: "meta-lead-ads",
    name: "Meta Lead Ads",
    eyebrow: "Paid Social",
    title: "Generate high-quality leads from the audiences already engaging with your brand.",
    summary:
      "We design Meta Lead campaigns that target the right audience, reduce friction, and turn interest into qualified inquiries across Facebook and Instagram.",
    intro:
      "The focus is on efficient audience targeting, persuasive creative, and simplified conversion paths that make it easy for prospects to respond.",
    highlights: [
      "Audience segmentation and retargeting",
      "Lead form optimization and funnel design",
      "Creative testing for stronger engagement",
      "Campaign refinement for better cost efficiency",
    ],
    benefits: [
      "Reach users who match your ideal customer profile",
      "Capture leads without requiring a difficult website journey",
      "Improve lead quality with better targeting and messaging",
    ],
    idealFor: "Businesses wanting to scale lead generation through social discovery and audience-based targeting.",
    cta: "Turn ad engagement into qualified lead volume.",
  },
  {
    slug: "web-development",
    name: "Web Development",
    eyebrow: "Digital Experience",
    title: "Build a site that looks professional and converts visitors into customers.",
    summary:
      "We create responsive, conversion-focused websites that reflect your brand, improve user experience, and support your sales and marketing efforts.",
    intro:
      "A strong website is more than a digital presence—it should guide users, build trust, and move them toward action.",
    highlights: [
      "Responsive design across all devices",
      "Clear user journeys and conversion-focused layouts",
      "Fast-loading performance and technical optimization",
      "Brand-aligned design with business goals in mind",
    ],
    benefits: [
      "Improve user trust and brand perception",
      "Increase conversion opportunities on every page",
      "Create a stronger foundation for ad traffic and SEO",
    ],
    idealFor: "Companies that need a stronger online presence, modern brand presentation, and better lead conversion.",
    cta: "Build a website that earns trust and turns attention into action.",
  },
  {
    slug: "ai-video-creation",
    name: "AI Video Creation",
    eyebrow: "Content Production",
    title: "Create scroll-stopping video content that amplifies your brand message.",
    summary:
      "We produce engaging AI-assisted videos for ads, social media, and campaigns that help businesses communicate clearly and stand out online.",
    intro:
      "Video content is one of the fastest ways to improve engagement, retention, and brand recall across digital channels.",
    highlights: [
      "Ad-ready short-form video creative",
      "Brand-aligned visual storytelling",
      "Multi-platform content production",
      "Fast turnaround with scalable creative testing",
    ],
    benefits: [
      "Increase engagement with memorable content",
      "Strengthen awareness across paid and organic channels",
      "Scale creative output without compromising quality",
    ],
    idealFor: "Brands looking to improve visibility, storytelling, and campaign performance through video content.",
    cta: "Turn attention into engagement with compelling video creative.",
  },
];
